import React from 'react'
import PropTypes from 'prop-types'
import Router from 'common/modules/router'
import WizardRedux from 'common/pkgs/WizardRedux'

const CheckoutWithPlan = (props) => {
    const {
        wizardName,
        accessToken,
        optionId,
        popupId,
    } = props

    return (
        <WizardRedux.Wrapper
            submitActionType={Router.types.PUSH}
            submitPayload={{
                optionId,
                popupId,
                url: {
                    pathname: '/thank-you',
                    query: {
                        ...(wizardName && { id: wizardName }),
                        completedWizard: 'CheckoutWizard',
                    },
                },
                as: {
                    pathname: '/thank-you',
                    query: {
                        ...(wizardName && { id: wizardName }),
                        completedWizard: 'CheckoutWizard',
                    },
                },
            }}
            id="CheckoutWizard"
        >
            {!accessToken && (
                <WizardRedux.StepRoute
                    url="/login"
                    as="/login"
                />
            )}
            <WizardRedux.StepRoute
                method="replace"
                url="/finalize-payment"
                as="/finalize-payment"
            />
            {/* <WizardRedux.StepRoute
                url="/select-newsletters"
                as="/select-newsletters"
            /> */}
        </WizardRedux.Wrapper>
    )
}

CheckoutWithPlan.defaultProps = {
    accessToken: null,
}

CheckoutWithPlan.propTypes = {
    wizardName: PropTypes.string.isRequired,
    accessToken: PropTypes.string,
    optionId: PropTypes.string.isRequired,
    popupId: PropTypes.string.isRequired,
}

export default CheckoutWithPlan
